import { render } from "./NotificationContacts.vue?vue&type=template&id=47ff4e2e"
import script from "./NotificationContacts.vue?vue&type=script&lang=js"
export * from "./NotificationContacts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__